var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jam:computer-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.625 34.25H39.375C39.8723 34.25 40.3492 34.4475 40.7008 34.7992C41.0525 35.1508 41.25 35.6277 41.25 36.125C41.25 36.6223 41.0525 37.0992 40.7008 37.4508C40.3492 37.8025 39.8723 38 39.375 38H5.625C5.12772 38 4.65081 37.8025 4.29917 37.4508C3.94754 37.0992 3.75 36.6223 3.75 36.125C3.75 35.6277 3.94754 35.1508 4.29917 34.7992C4.65081 34.4475 5.12772 34.25 5.625 34.25ZM7.5 8H37.5C38.4946 8 39.4484 8.39509 40.1516 9.09835C40.8549 9.80161 41.25 10.7554 41.25 11.75V30.5C41.25 30.9973 41.0525 31.4742 40.7008 31.8258C40.3492 32.1775 39.8723 32.375 39.375 32.375H5.625C5.12772 32.375 4.65081 32.1775 4.29917 31.8258C3.94754 31.4742 3.75 30.9973 3.75 30.5V11.75C3.75 10.7554 4.14509 9.80161 4.84835 9.09835C5.55161 8.39509 6.50544 8 7.5 8ZM37.5 28.625V11.75H7.5V28.625H37.5Z",
    fill: "#4555BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearn);
export default __webpack_public_path__ + "static/media/learn.0d43befdb44ff21f06448193cf544989.svg";
export { ForwardRef as ReactComponent };